import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=c24a22d6&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupComponent.vue?vue&type=style&index=0&id=c24a22d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24a22d6",
  null
  
)

export default component.exports